/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface DynamicModuleUiModuleBody
 */
export interface DynamicModuleUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof DynamicModuleUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicModuleUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicModuleUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicModuleUiModuleBody
     */
    moduleType: DynamicModuleUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof DynamicModuleUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof DynamicModuleUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof DynamicModuleUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof DynamicModuleUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {string}
     * @memberof DynamicModuleUiModuleBody
     */
    schemaId: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof DynamicModuleUiModuleBody
     */
    data?: { [key: string]: object; };
}

/**
    * @export
    * @enum {string}
    */
export enum DynamicModuleUiModuleBodyModuleTypeEnum {
    DYNAMIC_MODULE = 'DYNAMIC_MODULE'
}



